export default {
  paragraph: 'p',
  'heading-1': 'h1',
  'heading-2': 'h2',
  'heading-3': 'h3',
  'heading-4': 'h4',
  'heading-5': 'h5',
  'heading-6': 'h6, ',
  'ordered-list': 'ol',
  'unordered-list': 'ul',
  'list-item': 'li',
  hr: 'hr',
  blockquote: 'blockquote',
};
